{
  "eyebrow": "Elige tu plan",
  "title": "El plan que se adapta a tu equipo.",
  "sub": "30 días de prueba gratuita en todos los planes. Sin tarjeta. Cancela cuando quieras.",
  "bill": {
    "month": "Mensual",
    "year": "Anual",
    "save": "Ahorra 15%"
  },
  "fam": {
    "time": "Tiempo y operaciones",
    "project": "Proyectos y control de costes"
  },
  "compare": "Comparar todas las funciones",
  "compareHide": "Ocultar comparativa",
  "included": "Incluido",
  "select": "Elegir {{plan}}",
  "selected": "Seleccionado",
  "recommended": "Más popular",
  "pricePerMonth": "/ usuario / mes",
  "pricePerYear": "/ usuario / año",
  "base": "base / mes",
  "admins": "2 administradores incluidos",
  "continueCta": "Continuar con {{plan}}",
  "continuePick": "Elige un plan para continuar",
  "catalogError": "Catálogo de precios no disponible. Reintenta para cargar los precios más recientes.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Cumplimiento y registro simple",
    "timeProBest": "Operaciones de equipo",
    "projectBasicBest": "Proyectos y control de costes",
    "projectProBest": "Gestión avanzada de proyectos",
    "feat": {
      "timeBasic": {
        "timeTracking": "Registro de tiempo",
        "absencesHolidays": "Ausencias y vacaciones",
        "transport": "Registros de transporte",
        "workLocations": "Ubicaciones de trabajo y GPS",
        "mobileApp": "App móvil para empleados"
      },
      "timePro": {
        "everythingTime": "Todo lo de Time Basic",
        "overtime": "Registro de horas extra",
        "scheduling": "Planificación de turnos",
        "documents": "Documentos de empleados",
        "officeOps": "Funciones de oficina (registro de actividad, correcciones)",
        "addonsAvailable": "Complementos disponibles: seguimiento de proyectos, VTT",
        "internalMessaging": "Mensajería interna (chat de la empresa)"
      },
      "projectBasic": {
        "everythingTime": "Todo lo de Time Basic",
        "projects": "Proyectos con control de costes",
        "extras": "Trabajo y materiales adicionales",
        "subcontractors": "Gestión de subcontratistas",
        "checkInOut": "Registro de entrada / salida de trabajadores",
        "internalMessaging": "Mensajería interna (chat de la empresa)"
      },
      "projectPro": {
        "everythingAll": "Todo lo de Time Pro + Project Basic",
        "projectTransport": "Transporte por proyecto",
        "fullSuite": "Suite completa de productividad",
        "prioritySupport": "Soporte prioritario",
        "internalMessaging": "Mensajería interna (chat de la empresa)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Comparar todas las funciones",
    "subtitle": "Todo lo que incluye cada plan, lado a lado.",
    "cat": {
      "timeAttendance": "Tiempo y asistencia",
      "projectCost": "Proyecto y control de costes",
      "support": "Soporte"
    },
    "val": {
      "upTo4": "Hasta 4",
      "unlimited": "Ilimitado",
      "soon": "Pronto",
      "optional": "Opcional",
      "years5": "5 años",
      "years10": "10 años"
    },
    "row": {
      "mobileDesktop": "App móvil y de escritorio",
      "gpsCheckin": "Fichaje con un toque y GPS",
      "holidayAbsenceOvertime": "Vacaciones, ausencias y horas extra",
      "teamMembers": "Miembros del equipo",
      "workLocations": "Ubicaciones de trabajo",
      "registrationsPerMonth": "Registros / usuario / mes",
      "irregularMap": "Fichaje irregular en el mapa",
      "expenseManagement": "Gestión de gastos",
      "employeeDocuments": "Documentos de empleados",
      "openApi": "API abierta",
      "navigation": "Navegación a los centros de trabajo",
      "projectManagement": "Gestión de proyectos (presupuesto)",
      "subprojects": "Subproyectos",
      "subcontractorManagement": "Gestión de subcontratistas",
      "extraWorkMaterials": "Trabajos y materiales extra",
      "transportProjects": "Transporte vinculado a proyectos",
      "fullSuite": "Suite de productividad completa",
      "prioritySupport": "Soporte prioritario",
      "languages12": "Disponible en 12 idiomas",
      "manualTransport": "Distancia de transporte manual",
      "reportsExcel": "Informes y exportación a Excel",
      "frontendLocations": "Ubicaciones creadas por empleados",
      "checkInWork": "Check-in/out@work (Bélgica)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Descripciones e imágenes de proyectos",
      "dataStorage": "Almacenamiento de datos",
      "schedulingPlanning": "Planificación",
      "messagingNotifications": "Mensajería · Notificaciones"
    }
  }
}
